export const list = {
  table: {
    name: 'Name',
    manufacture: 'Manufacturer',
    supplier: 'Supplier',
    price: 'Price',
    inventory: 'Inventory',
  },
  pageHeader: {
    title: 'Washing Machine Part',
    new: 'New',
  },
}
